(function() {
       'use strict';

       angular.module('quantixApp').controller('ConsolidatedFileUploadController',
    		   ConsolidatedFileUploadController);

       ConsolidatedFileUploadController.$inject = [ '$scope', '$http', '$timeout'];

       function ConsolidatedFileUploadController($scope, $http, $timeout) {
    	   
    	   
    	   $scope.successRep = '';

           $scope.uploadConsolidatedFileforuser = function(fileUpload) {
               
                        var fd = new FormData();
                        fd.append('file', fileUpload);   
                       
                        $http.post('api/adminScreen/uploadConsolidatedFileforuser', fd, {
                        	 responseType : 'arraybuffer',
                               headers : {
                                      'Content-Type' : undefined
                               }
                        }).then(function(response) {

                               $scope.fileError = '';
                               $scope.successRep = 'OK';
                             
                        }, function(errordata) {

                               $scope.fileError = 'Invalid Format.';
                               
                               $timeout(function(){
                            	   $scope.fileError = '';
                               },2000)

                        });
                 
           }
           
	
       
       }


})();